import { useState, useEffect } from 'react';

export default function LoadingScreen() {
  const [currentText, setCurrentText] = useState(0);
  
  const loadingTexts = [
    'Готовим ваши итоги года…',
    'Считаем часы в игре…',
    'Ищем ваши любимые игры…',
    'Подбираем подарок…',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentText((prev) => (prev + 1) % loadingTexts.length);
    }, 1500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="text-center">
        {/* Spinner */}
        <div className="relative w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 mx-auto mb-8 sm:mb-12">
          <div className="absolute inset-0 rounded-full border-4 border-white/10" />
          <div 
            className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#00d4ff] border-r-[#a855f7] animate-spin"
            style={{ animationDuration: '1s' }}
          />
          <div className="absolute inset-4 sm:inset-6 rounded-full bg-gradient-to-br from-[#00d4ff]/20 to-[#a855f7]/20 blur-xl" />
        </div>

        {/* Loading Text */}
        <div className="h-16 sm:h-20 flex items-center justify-center px-4">
          <p 
            key={currentText}
            className="text-lg sm:text-xl md:text-2xl text-white/80 animate-fadeInUp"
          >
            {loadingTexts[currentText]}
          </p>
        </div>
      </div>
    </div>
  );
}
